import type { GraphQLError } from 'graphql/error/GraphQLError';
import ErrorCode from '@graphql/errors/ErrorCode';
import type ValidationErrorExtensions from '@graphql/errors/validation/ValidationErrorExtensions';

export default function isValidationError(
  error?: GraphQLError,
): error is Omit<GraphQLError, 'extensions'> & { extensions: ValidationErrorExtensions } {
  return error?.extensions.code === ErrorCode.VALIDATION;
}
